const emulator = false;
export const environment = {
  name: 'Development',
  emulator,
  production: false,
  localDataStoresOnly: false,
  firebase: {
    apiKey: 'AIzaSyAZyjwZRUPoYcAVzfvMq0oUDD9m4ZYC-Ys',
    authDomain: 'blume-method-testing.firebaseapp.com',
    projectId: 'blume-method-testing',
    storageBucket: 'blume-method-testing.appspot.com',
    messagingSenderId: '1004422004526',
    appId: '1:1004422004526:web:d900381c888c0450fcc4bf',
    measurementId: 'G-JZBDH2J27J',
  },
  emailLinkLoginRedirectURL: emulator ? 'http://localhost:8100/team' : 'https://testing.v3.blumemethod.app/team',
  forgotPasswordLinkUrl: emulator
    ? 'http://localhost:8100/auth-actions'
    : 'https://testing.v3.blumemethod.app/auth-actions',
  logRocketKey: 'g8a1fw/blume-method-app-testing',
  // Static scheduling links for the V3 booking prompts (86e2dwhcu), keyed by
  // surface. Configuration, not code: empty string = no link configured; the
  // in-app acknowledgement ("we'll reach out") stands alone.
  v3InfoSessionBookingUrl: 'https://calendly.com/patrick-blumemethod/introduction-to-the-blume-method',
  v3OnboardingBookingUrl: 'https://calendly.com/patrick-blumemethod/blume-v3-onboarding',
  // Time-sensitive webinar promo (V3 governance surfaces + My Blume home tile).
  // Auto-hides after `activeUntil` (local date, inclusive) via isWebinarPromoActive(),
  // so a past date never lingers. Configuration, not code — change or disable it here.
  webinar: {
    registrationUrl: 'https://us02web.zoom.us/webinar/register/WN_lDUv072JQU23zWKQBIVa5Q',
    activeUntil: '2026-07-29',
    shortLabel: 'Webinar 07/29!',
    ariaLabel: 'Register for the webinar on July 29, 2026',
  },
  appCheck: undefined as { recaptchaSiteKey: string; isTokenAutoRefreshEnabled: boolean } | undefined,
};
